import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-sidebar.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

/**
 * @customElement logistik-component-base-page-layout
 */
@customElement('logistik-component-base-page-layout')
export class LogistikComponentBasePageLayout extends ChemistryLitElement {
  @property({ type: Boolean, attribute: 'no-section' }) noSection?: boolean;

  @state() size = new WindowSizeController(this);

  override render() {
    const content = html`
      <cr-flex
        space="xl"
        ${css({
          width: '100%',
          paddingTop: this.size.mobile ? this.spacing.md : this.spacing.xl,
          paddingBottom: this.size.mobile ? this.spacing.md : this.spacing.xl,
          ...(this.noSection ? { paddingLeft: this.spacing.md, paddingRight: this.spacing.md } : {}),
        })}
      >
        <slot></slot>
      </cr-flex>
    `;
    if (this.noSection) return content;
    return html` <cr-section> ${content} </cr-section> `;
  }
}
